import { useEffect, useRef, useState } from "react";

/**
 * A `useState` wrapper that resets the state to the initial value whenever a
 * cached page is restored. This hook solves the problem of a intermediate state
 * (eg: loading spinner) showing whenever the user clicks the button from the
 * checkout.
 */
export function useBfState<T>(initialState: T) {
  const initialValue = useRef(initialState);
  const stateHook = useState(initialState);
  const [_, setState] = stateHook;

  useEffect(() => {
    const disableCachedLoading = (event: PageTransitionEvent) => {
      if (event.persisted) {
        setState(initialValue.current);
      }
    };
    window.addEventListener("pageshow", disableCachedLoading);
    return () => {
      window.removeEventListener("pageshow", disableCachedLoading);
    };
  }, [setState]);

  return stateHook;
}
